var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "M0 11h29v1H0zM0 5.5h29v1H0zM0 0h29v1H0z"
  })));
};
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDI5IDEyIj48dGl0bGU+bWVudTE8L3RpdGxlPjxyZWN0IHk9IjExIiB3aWR0aD0iMjkiIGhlaWdodD0iMSIgZmlsbD0iIzkzOTM5MyIvPjxyZWN0IHk9IjUuNSIgd2lkdGg9IjI5IiBoZWlnaHQ9IjEiIGZpbGw9IiM5MzkzOTMiLz48cmVjdCB3aWR0aD0iMjkiIGhlaWdodD0iMSIgZmlsbD0iIzkzOTM5MyIvPjwvc3ZnPg==";